import IsibuteDocumentComponent from "./IsibuteDocumentComponent";

class IsibuteDocumentTitle extends IsibuteDocumentComponent {};

export default IsibuteDocumentTitle;
